import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return "None";
  }
  if (typeof profile.connects === "number") {
    if (profile.connects < 10 && profile.connects !== 0) {
      return `0${profile.connects}`;
    } else if (profile.connects === 0) {
      return "None";
    } else {
      return profile.connects;
    }
  } else {
    return 10;
  }
};
//VERIFY IF THE JWT IS SET
const getMyFollowersCount = createSelector(getData, followers => followers);
export default getMyFollowersCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyFollowersCount.js